// path consts
// general paths
export const PATH_SUCCESS = '/success';
export const PATH_ERROR = '/fatal-error';

// modal name list
export const MODAL_ACCOUNT = 'accountModal';
